import React, { useState } from 'react';
import { Card, CardContent, Typography, Button, Divider } from '@material-ui/core';
import { makeStyles } from '@mui/styles';
import { useHistory } from 'react-router-dom';
import { getDocumentByFileStoreId } from '@egovernments/digit-ui-libraries/src/utils/fileType';

const useStyles = makeStyles((theme) => ({
  card: {
    maxWidth: 350,
    margin: '10px',
    boxShadow: 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;',
    height: 420,
  },
  header: {
    backgroundColor: '#2F5EA8',
    color: '#fff',
    padding: '10px',
    fontSize: '15px',
    borderRadius: '7px',
  },
  link: {
    color: '#2F5EA8',
    textDecoration: 'none',
    fontSize: '14px',
    display: 'block',
    margin: '10px',
    transition: 'color 0.3s ease, text-decoration 0.3s ease, background-color 0.3s ease',
    cursor: 'pointer'
  },
  imageContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: '30px 0',
  },
  image: {
    width: '120px',
    height: '60px',
    marginRight: '10px',
  },
  imageText: {
    fontWeight: 'bold',
  },
  view: {
    padding: '6px 12px',
    color: '#1F4A7C',
    marginLeft: '200px',
  },
  divider: {
    margin: '5px 0',
  },
}));

const CommonInfo = ({ heading, paragraphs, buttonLabel, link }) => {
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const classes = useStyles();
  const history = useHistory();
  const handleButtonClick = () => {
    history.push(link);
  };


  return (
    <Card className={classes.card}>
      <CardContent>
        <Typography variant="h6" className={classes.header}>
          {heading}
        </Typography>

        {paragraphs.map((paragraph, index) => (
          paragraph.image ? (
            <div key={index} className={classes.imageContainer}>
              <img src={paragraph.image} alt={paragraph.text} className={classes.image} />
              <p className={classes.link} onClick={() => getDocumentByFileStoreId(paragraph.link, setIsPreviewLoading)} rel="noopener noreferrer">
                <span className={classes.imageText}>{paragraph.text}</span>
              </p>
            </div>
          ) : (
            <div key={index}>
              <p className={classes.link} onClick={() => getDocumentByFileStoreId(paragraph.link, setIsPreviewLoading)} rel="noopener noreferrer">
                {paragraph.text}
              </p>
              {index < paragraphs.length - 1 && <Divider className={classes.divider} />}
            </div>
          )
        ))}

        <Button className={classes.view} onClick={handleButtonClick}>
          {buttonLabel}
        </Button>
      </CardContent>
    </Card>
  );
};

export default CommonInfo;
